"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasStartupTasks = exports.isStartupTask = exports.StartupTaskProvider = void 0;
exports.StartupTaskProvider = Symbol('StartupTaskProvider');
function isStartupTask(arg) {
    if (typeof arg === 'object') {
        if (arg.command !== undefined &&
            typeof arg.command === 'string') {
            return (arg.args === undefined ||
                (arg.args !== undefined &&
                    Array.isArray(arg.args)));
        }
    }
    return false;
}
exports.isStartupTask = isStartupTask;
function hasStartupTasks(arg) {
    if (typeof arg === 'object') {
        return (arg.tasks !== undefined &&
            Array.isArray(arg.tasks) &&
            Boolean(arg.tasks.length) &&
            arg.tasks.every(isStartupTask));
    }
    return false;
}
exports.hasStartupTasks = hasStartupTasks;
//# sourceMappingURL=startup-task.js.map